import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang'
import ElementUI from 'element-ui';
import '@/assets/css/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

Vue.prototype.$axios = axios

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
Vue.component('VueSlickCarousel', VueSlickCarousel)

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.config.errorHandler = (err, vm, info) => {
    console.error('Vue Error:', err)
}

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
